import { useState } from "react";
import { Flex, Heading, Text } from "@radix-ui/themes";
import { useProfileContext } from "context";
import { useKnowledgeAdapters } from "hooks/aiAssistant/useKnowledge";
import Sources from "./knowledge/Sources";
import Entities from "./knowledge/Entities";
import "./AIAssistantKnowledge.css";

export default function AIAssistantKnowledge() {
  const { userProfile } = useProfileContext();
  return userProfile?.user_role === "Owner" ? <Knowledge key={`${userProfile.organisation_id}:${userProfile.user_id}`} />
    : <Text role="alert">Only organisation Owners can manage Knowledge.</Text>;
}

function Knowledge() {
  const adapters = useKnowledgeAdapters();
  const [tab, setTab] = useState("sources");
  const [source, setSource] = useState(null);
  const selectTab = value => { setTab(value); if (value === "sources") setSource(null); };
  return <Flex direction="column" gap="5" width="100%" className="ai-knowledge">
    <div><Heading size="6">Knowledge</Heading><Text size="2" color="gray">Keep your Assistant’s knowledge current and choose what it can use in answers.</Text></div>
    <div role="tablist" aria-label="Knowledge sections" className="knowledge-tabs">
      {["sources", "knowledge"].map(value => <button key={value} type="button" role="tab" id={`knowledge-tab-${value}`} aria-controls={`knowledge-panel-${value}`} aria-selected={tab === value}
        tabIndex={tab === value ? 0 : -1} onClick={() => selectTab(value)} onKeyDown={event => {
          if (["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) {
            event.preventDefault(); const next = event.key === "Home" ? "sources" : event.key === "End" ? "knowledge" : tab === "sources" ? "knowledge" : "sources";
            selectTab(next); document.getElementById(`knowledge-tab-${next}`)?.focus();
          }
        }}>{value === "sources" ? "Sources" : "Knowledge"}</button>)}
    </div>
    <div role="tabpanel" id={`knowledge-panel-${tab}`} aria-labelledby={`knowledge-tab-${tab}`}>
      {tab === "sources" ? <Sources adapters={adapters} onBrowse={value => { setSource(value); setTab("knowledge"); }} />
        : <Entities adapters={adapters} initialSource={source} />}
    </div>
  </Flex>;
}
